import { CLEAR_ERRORS, GET_ERRORS } from '../actions/types';

const initialState = {};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_ERRORS:
            return action.payload;
        // Add to your errors reducer
        case CLEAR_ERRORS:
            return {}; // Reset errors state
        default:
            return state;
    }
}
